import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { compose } from 'redux';
import { Admins, Props as WidgetProps } from './Admins';
import AdminsBoxContainer from './AdminsBox.container';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../../UserWidgets/_partials/WidgetBoxWide';
import EmptyState from '../../EmptyState';

import s from './Admins.scss';

class AdminsBoxWide extends React.Component<
  WidgetProps & WidgetBoxWideProps & WithTranslation
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      isEmpty,
      isOwner,
      widgetMenuRenderer,
      widgetMoveUp,
      widgetMoveDown,
      parentRef,
      widgetRemove,
      widgetBoxClassName,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        id={id}
        zone={zone}
        section={section}
        moduleId={props.moduleId}
        header={props.t(`widgets.group_admins.header`)}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        parentRef={parentRef}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(`widgets.group_admins.empty.title.owner`)}
              subtitle={props.t!(`widgets.group_admins.empty.subtitle.owner`)}
              buttonLabel={props.t!(
                `widgets.group_admins.empty.CTALabel.owner`
              )}
              withButton={true}
              onButtonClick={this.navigateToBrowse}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t(`widgets.group_admins.empty.title.visitor`)}
              subtitle={props.t(`widgets.group_admins.empty.subtitle.visitor`)}
            />
          )
        }
      >
        <Admins isOwner={isOwner} {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }
}
const enhance = compose(AdminsBoxContainer, withTranslation());

export default enhance(AdminsBoxWide) as React.ComponentType<{}>;
